var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarAffiliate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9675_761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.94238 5.78003L6.00488 9.32086M10.6774 13.995L14.2199 15.0575",
    stroke: "CurrentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73584 10.2641L14.535 5.46497",
    stroke: "CurrentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 4.58337C3.33325 4.74753 3.36558 4.91007 3.4284 5.06173C3.49122 5.21339 3.5833 5.35118 3.69937 5.46726C3.81544 5.58333 3.95324 5.67541 4.1049 5.73822C4.25655 5.80104 4.4191 5.83337 4.58325 5.83337C4.7474 5.83337 4.90995 5.80104 5.06161 5.73822C5.21326 5.67541 5.35106 5.58333 5.46714 5.46726C5.58321 5.35118 5.67528 5.21339 5.7381 5.06173C5.80092 4.91007 5.83325 4.74753 5.83325 4.58337C5.83325 4.41922 5.80092 4.25668 5.7381 4.10502C5.67528 3.95336 5.58321 3.81556 5.46714 3.69949C5.35106 3.58342 5.21326 3.49134 5.06161 3.42852C4.90995 3.36571 4.7474 3.33337 4.58325 3.33337C4.4191 3.33337 4.25655 3.36571 4.1049 3.42852C3.95324 3.49134 3.81544 3.58342 3.69937 3.69949C3.5833 3.81556 3.49122 3.95336 3.4284 4.10502C3.36558 4.25668 3.33325 4.41922 3.33325 4.58337Z",
    stroke: "CurrentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 4.58337C14.1667 4.91489 14.2984 5.23284 14.5329 5.46726C14.7673 5.70168 15.0852 5.83337 15.4167 5.83337C15.7483 5.83337 16.0662 5.70168 16.3006 5.46726C16.5351 5.23284 16.6667 4.91489 16.6667 4.58337C16.6667 4.25185 16.5351 3.93391 16.3006 3.69949C16.0662 3.46507 15.7483 3.33337 15.4167 3.33337C15.0852 3.33337 14.7673 3.46507 14.5329 3.69949C14.2984 3.93391 14.1667 4.25185 14.1667 4.58337Z",
    stroke: "CurrentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 15.4166C14.1667 15.7481 14.2984 16.0661 14.5329 16.3005C14.7673 16.5349 15.0852 16.6666 15.4167 16.6666C15.7483 16.6666 16.0662 16.5349 16.3006 16.3005C16.5351 16.0661 16.6667 15.7481 16.6667 15.4166C16.6667 15.0851 16.5351 14.7672 16.3006 14.5327C16.0662 14.2983 15.7483 14.1666 15.4167 14.1666C15.0852 14.1666 14.7673 14.2983 14.5329 14.5327C14.2984 14.7672 14.1667 15.0851 14.1667 15.4166Z",
    stroke: "CurrentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 12.9166C3.33325 13.9112 3.72834 14.865 4.4316 15.5683C5.13486 16.2715 6.08869 16.6666 7.08325 16.6666C8.07781 16.6666 9.03164 16.2715 9.7349 15.5683C10.4382 14.865 10.8333 13.9112 10.8333 12.9166C10.8333 11.9221 10.4382 10.9682 9.7349 10.265C9.03164 9.56171 8.07781 9.16663 7.08325 9.16663C6.08869 9.16663 5.13486 9.56171 4.4316 10.265C3.72834 10.9682 3.33325 11.9221 3.33325 12.9166Z",
    stroke: "CurrentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9675_761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarAffiliate);
export default __webpack_public_path__ + "static/media/sidebar-affiliate.924064bb3a5a880048989133286cd9c5.svg";
export { ForwardRef as ReactComponent };